import React, { useEffect } from 'react'
import { toast } from 'react-toastify'
import { useHistory } from 'react-router-dom'
import { Formik, Form } from 'formik'
import * as Yup from 'yup'

import { Button, Textbox } from '../../../components/Form'

import { api } from '../../../services/api'

import { Container, Content } from './styles'

const validation = Yup.object({
    senha: Yup.string()
        .required('Senha obrigatória.')
        .min(6, 'A senha deve conter pelo menos 6 caracteres.'),
    confirmacao: Yup.string()
        .required('Confirme a senha digitada.')
        .oneOf([Yup.ref('senha')], 'As senhas não coincidem.')
})

export default function ({ match }) {
    const history = useHistory()

    useEffect(() => {
        async function checkToken() {
            try {
                await api.get(`pass_recover/${match.params.token}`)
            } catch (e) {
                toast.error(e.msg)

                history.push('/pass_recover')
            }
        }

        checkToken()
    }, [history, match.params])

    async function handleSubmit({ senha }) {
        try {
            await api.put('save_password', {
                token: match.params.token,
                senha
            })

            toast.success('Senha alterada com sucesso!')

            history.push('/login')
        } catch (e) {
            toast.error(e.msg)
        }
    }

    return (
        <Container>
            <Content className="animated fadeInUp faster delay-300ms bg-white text-slate-800">
                <Formik
                    initialValues={{ senha: '', confirmacao: '' }}
                    validationSchema={validation}
                    onSubmit={handleSubmit}
                >
                    {({ isSubmitting }) => (
                        <Form className="w-full">
                            <h1 className="text-slate-800">Recuperação de senha</h1>

                            <Textbox name="senha" type="password" label="Nova senha" />

                            <Textbox name="confirmacao" type="password" label="Confirme a nova senha" />

                            <Button type="submit" loading={isSubmitting}>Alterar minha senha</Button>
                        </Form>
                    )}
                </Formik>

            </Content>
        </Container>
    )
}
